<template>
  <nav class="sidebar-nav">
    <ul class="nav">
      <template v-for="(item, index) in navItems" id="sidebarCollapse" class="collapse" >
        <template v-if="item.title"  >
          <SidebarNavTitle
            :key="index"
            :name="item.name"
            :classes="item.class"
            :wrapper="item.wrapper"
            @click="sidebarCollapse"
          />
        </template>
        <template v-else-if="item.divider">
          <SidebarNavDivider :key="index" :classes="item.class"/>
        </template>
        <template v-else-if="item.label">
          <SidebarNavLabel
            :key="index"
            :name="item.name"
            :url="item.url"
            :icon="item.icon"
            :label="item.label"
            :classes="item.class"
          />
        </template>
        <template v-else>
          <template v-if="item.children">
            <!-- First level dropdown -->
            <SidebarNavDropdown :key="index" :name="item.name" :url="item.url" :icon="item.icon">
              <template v-for="(childL1, index1) in item.children">
                <template v-if="childL1.children">
                  <!-- Second level dropdown -->
                  <SidebarNavDropdown
                    :key="index1"
                    :name="childL1.name"
                    :url="childL1.url"
                    :icon="childL1.icon"
                  >
                    <li
                      :key="index2"
                      class="nav-item"
                      v-for="(childL2, index2) in childL1.children"
                    >
                      <SidebarNavLink
                        :name="childL2.name"
                        :url="childL2.url"
                        :icon="childL2.icon"
                        :badge="childL2.badge"
                        :variant="item.variant"
                      />
                    </li>
                  </SidebarNavDropdown>
                </template>
                <template v-else>
                  <SidebarNavItem :key="index1" :classes="item.class">
                    <SidebarNavLink
                      :name="childL1.name"
                      :url="childL1.url"
                      :icon="childL1.icon"
                      :badge="childL1.badge"
                      :variant="item.variant"
                    />
                  </SidebarNavItem>
                </template>
              </template>
            </SidebarNavDropdown>
          </template>
          <template v-else>
            <SidebarNavItem :key="index" :classes="item.class">
              <SidebarNavLink
                :name="item.name"
                :url="item.url"
                :icon="item.icon"
                :badge="item.badge"
                :variant="item.variant"
              />
            </SidebarNavItem>
          </template>
        </template>
      </template>
    </ul>
    <slot></slot>
  </nav>
</template>

<script>
import SidebarNavDivider from "@coreui/vue/src/components/Sidebar/SidebarNavDivider";
import SidebarNavDropdown from "@coreui/vue/src/components/Sidebar/SidebarNavDropdown";
import SidebarNavLink from "@coreui/vue/src/components/Sidebar/SidebarNavLink";
import SidebarNavTitle from "@coreui/vue/src/components/Sidebar/SidebarNavTitle";
import SidebarNavItem from "@coreui/vue/src/components/Sidebar/SidebarNavItem";
import SidebarNavLabel from "@coreui/vue/src/components/Sidebar/SidebarNavLabel";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import * as $ from 'jquery';

export default {
  name: "SideNav",
  props: {
    navItems: {
      type: Array,
      required: true,
      default: () => []
    },
  },
  components: {
    SidebarNavDivider,
    SidebarNavDropdown,
    SidebarNavLink,
    SidebarNavTitle,
    SidebarNavItem,
    SidebarNavLabel,
    VuePerfectScrollbar
  },
  data() {
    return {
      show: true,
      psSettings: {
        maxScrollbarLength: 200,
        minScrollbarLength: 40,
        suppressScrollX: true,
        wheelPropagation: false,
        interceptRailY: styles => ({ ...styles, height: 0 }),
        isRtl: true,
        sidebarFlag: 1
      }
    };
  },
  mounted() {},
  methods: {
    scrollHandle(evt) {
      // console.log(evt)
    },
    sidebarCollapse() {
debugger
      $('#sidebarCollapsible').collapse({
        toggle: true
      });
      this.sidebarFlag = true
      // console.log(this.sidebarFlag)
      $('.collapse').collapse('show')
    },
  },
  watch: {
    navItems(val) {
      // console.log(val);
    }
  }
};
</script>

<style scoped lang="css">
.scroll-area {
  position: absolute;
  height: 100%;
  margin: auto;
}
.rtl .ps__rail-y {
  right: auto !important;
  left: 0;
}
</style>
